import * as React from "react";
import {
	Group,
	UnstyledButton,
	Text,
	createStyles,
	useMantineTheme,
} from "@mantine/core";
import { ReactNode } from "react";
import { Icon } from "../icons/Icon";

const useStyles = createStyles((theme, { active }: { active: boolean }) => ({
	activeBar: {
		borderLeftColor: active ? theme.colors[theme.primaryColor][7] : "white",
		borderLeftWidth: "0.5rem",
		borderLeftStyle: "solid",
	},
	link: {
		textDecoration: "none",
		width: "100%",
	},
}));

export interface _InternalNavElement {
	icon: string;
	label: string;
	href: string;
}
interface _InternalNavItemProps {
	navElement: _InternalNavElement;
	minimal: boolean;
	activeHref: string;

	makeWrapper: (url: string | undefined, child: ReactNode) => ReactNode;
	onClickItem: () => void; //closes mobile nav
}

export default function _InternalNavItem({
	navElement,
	minimal,
	activeHref,
	makeWrapper,
	onClickItem,
}: _InternalNavItemProps) {
	const active = activeHref === navElement.href;
	const { classes } = useStyles({ active });
	const theme = useMantineTheme();

	const element = (
		<UnstyledButton
			sx={(theme) => ({
				display: "block",
				width: "100%",
				padding: theme.spacing.xs,
				borderRadius: theme.radius.sm,
				color: active ? theme.black : theme.colors.dark[2],
				backgroundColor: active ? theme.colors.gray[0] : undefined,
				"&:hover": {
					backgroundColor: theme.colors.gray[0],
				},
			})}
			key={window.location.pathname}
			onClick={() => onClickItem()}
		>
			<Group>
				<Icon
					icon={navElement.icon}
					color={active ? theme.black : theme.colors.dark[2]}
				/>

				{minimal ? undefined : <Text size="md">{navElement.label}</Text>}
			</Group>
		</UnstyledButton>
	);

	return (
		<Group className={classes.activeBar}>
			<div className={classes.link}>
				{makeWrapper(navElement.href, element)}
			</div>
		</Group>
	);
}
